import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { ExportToCSVService } from 'common/data';

class ExportToCSVStore extends BaseStore {
	constructor(rootStore) {
		super(new ExportToCSVService(rootStore.app.baasic.apiClient));
	}

	@action
	getOrdersForExport = async filter => {
		const response = await this.service.getOrdersForExport(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
		return this.response;
	};
}

export default ExportToCSVStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/ExportToCSVStore.js